'use strict';

// Navigation config.
global.__NavigationConfig = {
	storageKey: 'navigationState',
	navigationHoverDealy: 250,
	navigationCloseAfter: 1000,
	defaultNavigation: 'default'
};

const Config = global.__NavigationConfig;

// Navigation state.
global.__NavigationState = {
	navigation: Config.defaultNavigation, // Active navigation id.
	level: 0,
	mobileNavigationItemsTemplate: '',
	navigationLookup: {},
	mobileNavigationData: {},
	navigationLinksById: {},
	timer: false,
	timers: {},
	history: [],
	isStickyNav: false,
	stickyLimit: 0
};

const State = global.__NavigationState;

const mobileNavigationItemsTemplate = document.querySelector('#common-navigation-mobile-navigation-list-template');
const mobileNavigationData = document.querySelector('#navigation-data-mobile');

State.mobileNavigationItemsTemplate = mobileNavigationItemsTemplate ? mobileNavigationItemsTemplate.textContent.trim() : '';

import NavigationActions from './common-navigation-actions';
import NavigationListeners from './common-navigation-listeners';


/**
 * Indexes navigation. Used for easy item children fetching when clicking mobile menu navigation items.
 *
 * @param {Object[]} navigationData - Navigation data.
 * @param {Object} [data] - Used only when function calls itself.
 * @returns
 */
function indexNav(navigationData, data) {

	if (!navigationData) {
		return navigationData;
	}

	if (!data || (data && data.index === undefined)) {
		data = {
			index: 0
		}
	}

	for (const navItem of navigationData) {

		navItem.navItemId = data.index;
		data.index++;

		State.navigationLookup['nav-item-' + navItem.navItemId] = navItem;

		if (Array.isArray(navItem.children) && navItem.children.length) {
			indexNav(navItem.children, data);
		}
	}

	return navigationData;

}

/**
 * Init navigation.
 */
function init() {

	State.mobileNavigationData = indexNav(JSON.parse(mobileNavigationData ? mobileNavigationData.textContent.trim() : '[]'));

	for (const navigation of State.mobileNavigationData) {
		State.navigationLinksById[navigation.navId] = navigation.url || '/fi/';
	}

	NavigationActions.updateGlobals();
	NavigationListeners.updateGlobals();

	const restoredState = NavigationActions.readNavigationState();
	if (restoredState && restoredState.navigation) {
		State.navigation = restoredState.navigation;
	}

	if(document.location.pathname === '/fi/') {
		NavigationActions.deleteNavigationState();
	} else {
		NavigationActions.restoreNavigationState(restoredState);
	}

	NavigationListeners.addClickListeners();
	NavigationListeners.addMouseListeners();
	NavigationListeners.addKeyListeners();
	NavigationListeners.addScrollListeners();

	// Prevents flicker if navigation changes when customer has selected target group.
	const desktopNavBar = document.querySelector('.o-header .m-navigations');
	if (desktopNavBar) {
		desktopNavBar.classList.remove('m-navigations--hidden');
	}
}


export default { init };
